export default __webpack_public_path__ + "static/media/Ubuntu-Bold.50114233.ttf";